export const environment = {
  production: false,
  baseUrl: 'https://dev.ravisacademy.com',
  googleUrl:
    'https://accounts.google.com/o/oauth2/v2/auth?scope=profile%20email&redirect_uri=https://dev.ravisacademy.com/api/gmail/webhook&response_type=code&client_id=994460556001-hfak5i4cffhhbesaanbfslkuahs4rdok.apps.googleusercontent.com&approval_prompt=force',
  facebookUrl:
    'https://www.facebook.com/v5.0/dialog/oauth?client_id=453741068674722&redirect_uri=https://dc41b4dd.ngrok.io/api/webhook&state=random',
  stripePublishableKey:
    'pk_test_51NGCkfFG3Dh3H5V4g9obRt9zKfRnPJCH5CnpAwMiFMyg4Yab1GDsZAqpUJv8fIcRB49Y9m2wdUcz8K2ftaG4gfSE00gcMnujpU',
  location: 'https://dev.ravisacademy.com/app',
};
